import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: 100,
		marginLeft: 100,
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	formControl: {
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	detailStyle: {
		display: "flex",
		flexDirection: "column",
		marginLeft: "20px",
	},
	assetManualButton: {
		backgroundColor: "#022F40",
		color: "white",
		height: "30px",
		width: "50%",
		borderRadius: 5,
		'&:hover': {
			backgroundColor: "#022F40",
		},
	},
	equipmentWatchValues: {
		display: "flex",
		flexDirection: "row",
		alignContent: "space-between",
		marginTop: theme.spacing(2),
		width: "35%",
	},
	headers: {
		display: "flex",
		flexDirection: "row",
	},
	originalDetail: {
		display: "flex",
		flexDirection: "row",
	},
	overrideDetail: {
		display: "flex",
		flexDirection: "column",
		alignContent: "space-between",
		maxWidth: "40%",
		margin: theme.spacing(2),
		width: "280px",
	},
	changeButtons: {
		display: "flex",
		flexDirection: "column",
		alignContent: "space-between",
		justifyContent: "space-around",
		maxWidth: "30%",
		margin: theme.spacing(2),
	},
	details: {
		display: "flex",
		alignItems: "flex-start",
		width: "100%",
	},
	Value: {
		marginTop: theme.spacing(1.75),
		width: "90px",
		marginLeft: theme.spacing(0.5),
		marginRight: theme.spacing(0.5),
	},
	assetTypeGroup: {
		width: "250px",
	},
	assetType: {
		width: "250px",
	},
	constructionType: {
		width: "250px",
	},
	sellingDetails: {
		marginTop: theme.spacing(2.75),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(0.5),
		width: "25%",
	},
	verticalGap: {
		marginTop: theme.spacing(2),
	},
	horizontalGap: {
		marginLeft: theme.spacing(2),
	},
	leftShift: {
		marginRight: "200px",
	},
	otherHeaders: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-around",
		width: "45%",
	},
	input: {
		display: "none",
	},
	rowDetails: {
		width: "50%",
		marginLeft: "5px",
	},
	boxDesign: {
		border: "1px solid rgba(224, 224, 224, 1)",
		padding: 5,
		//borderRadius: 10,
		//minHeight: 300,
	},
	labelRoot: {
		fontSize: 16,
		color: "black",
		fontWeight: "bold",
	},
	textColor: {
		fontSize: 16,
		color: "black",
	},
	buttonSize: {
		backgroundColor: "#022F40",
		color: "white",
		minWidth: "10px",
		maxWidth: "100%",
	},
}));
